import React, { Component } from "react";
import PropTypes from "prop-types";
import { NavLink } from "react-router-dom";
import { Menu } from "antd";

import { Spinner, ErrorMsg } from "../";

class ContentLinks extends Component {
  state = {
    links: {
      loading: true,
      error: false,
      errorMsg: "",
      data: null
    }
  };

  componentDidMount() {
    const { internalAPI } = this.props;

    const self = this;

    internalAPI
      .get("/names")
      .then(function(response) {
        self.setState(prevState => ({
          links: {
            ...prevState.links,
            loading: false,
            data: response.data
          }
        }));
      })
      .catch(error => {
        console.log("Error occurred in fetching content links", error);
        self.setState(prevState => ({
          links: {
            ...prevState.links,
            loading: false,
            error: true,
            errorMsg: error.message
          }
        }));
      });
  }

  render() {
    const { links } = this.state;
    let selectedKeys = [];
    if (this.props.selectedFile) selectedKeys.push(this.props.selectedFile);
    return (
      <div>
        {links.loading && <Spinner message={"loading menu"} />}
        {links.error && (
          <ErrorMsg
            message={"Error loading content"}
            description={links.errorMsg}
          />
        )}
        {links.data && (
          <Menu
            mode={"inline"}
            style={{ backgroundColor: "transparent" }}
            theme="dark"
            selectedKeys={selectedKeys}
          >
            {links.data.map(i => (
              <Menu.Item key={i}>
                <NavLink to={`/app/content/${i}`}>{i}</NavLink>
              </Menu.Item>
            ))}
          </Menu>
        )}
      </div>
    );
  }
}

ContentLinks.propTypes = {
  internalAPI: PropTypes.func.isRequired,
  selectedFile: PropTypes.string
};

export default ContentLinks;



// WEBPACK FOOTER //
// ./src/components/content_links/ContentLinks.jsx